import Navbar from "../components/ontario2c/Navbar.tsx";
import HeroSection from "../components/ontario2c/HeroSection.tsx";
import EventsSection from "../components/ontario2c/EventsSection.tsx";
import IssuesSection from "../components/ontario2c/IssuesSection.tsx";
import OpEdSection from "../components/ontario2c/OpEdSection.tsx";
import LatestPressSection from "../components/ontario2c/LatestPressSection.tsx";
import AboutSection from "../components/ontario2c/AboutSection.tsx";
import SignupSection from "../components/ontario2c/SignupSection.tsx";
import FooterSection from "../components/ontario2c/FooterSection.tsx";

export default function Ontario2() {
  return (
    <div className="min-h-screen w-full bg-[#00499d]">
      <Navbar />
      <div className="pt-14">
        <HeroSection />
        <EventsSection />
        <IssuesSection />
        <OpEdSection />
        <LatestPressSection />
        <AboutSection />
        <SignupSection />
        <FooterSection />
      </div>
    </div>
  );
}

